<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="TITLE">A Shorter Guide to The Holy Spirit</p>
<p class="SUBTITLE">Bible, Doctrine, Experience</p>
<p class="AUTHOR">Anthony C. Thiselton</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan</p>
<p class="COPYRIGHT">© 2016 Anthony C. Thiselton<br/>All rights reserved<br/><br/>Published 2016 by<br/>Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-­in-­Publication Data</p>
<p class="CIP">Names: Thiselton, Anthony C., author.<br/>Title: A shorter guide to the Holy Spirit : Bible, doctrine, experience / <br/>Anthony C. Thiselton.<br/>Description: Grand Rapids, Michigan : Eerdmans Publishing Company, 2016. | <br/>Includes bibliographical references.<br/>Identifiers: LCCN 2015043610 | ISBN 9780802873491 (pbk. : alk. paper)<br/>eISBN 9781467446266 (ePub)<br/>eISBN 9781467445863 (Kindle)<br/>Subjects: LCSH: Holy Spirit. | Holy Spirit—Biblical teaching.<br/>Classification: LCC BT121.3 .T453 2016 | DDC 231/.3—dc23 <br/>LC record available at http://lccn.loc.gov/2015043610</p>
<p class="URL"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Thiselton_A_Shorter_Guide.vue?0e264d04